import type {
	AppID,
	JsonObject,
	NubeComponent,
} from "@tiendanube/nube-sdk-internal-types";
import { dispatchInternalMessage } from "../../messages";

export function createWorkerIframeMessage(
	appId: AppID,
): (
	iframe: NubeComponent & { __internalId?: string },
	message: JsonObject,
) => void {
	return (
		iframe: NubeComponent & { __internalId?: string; src?: string },
		message: JsonObject,
	) => {
		const iframeId = iframe.__internalId;
		const src = iframe.src;

		if (iframeId) {
			dispatchInternalMessage(appId, "internal:iframe:message", {
				iframeId,
				message,
				src,
			});
		}
	};
}
